/**
 * Какой язык у экрана — правило в одном месте.
 *
 * ВИТРИНА (всё, у чего есть русский адрес): язык — из адреса, и только из него.
 * `/courses` английская, `/ru/courses` русская, что бы ни лежало в браузере:
 * иначе ссылка, отправленная другу, открылась бы у него на чужом языке.
 *
 * ВНЕ ВИТРИНЫ (кабинет, моделлер, экраны входа — у них адреса на язык нет):
 * побеждает выбор человека, сохранённый переключателем (`achp-lang`). Раньше
 * этот выбор читался один раз, при загрузке, и только если загрузка началась
 * вне витрины: вход через корень `/` (английская витрина) — а корень вошедшего
 * тут же уводит в кабинет, и туда же смотрит иконка приложения — ставил
 * английский, и кабинет человека с сохранённым русским открывался
 * по-английски.
 *
 * Выбора нет — берётся язык последней витрины, которую человек видел в этой
 * вкладке: читатель, нажавший «Кабинет» на `/ru`, попадает во вход и в кабинет
 * по-русски, хотя переключателя не трогал.
 *
 * Отдельный модуль, а не функция в провайдере: файл с компонентом и
 * утилитами ломает горячую перезагрузку (см. `lang-path.ts`).
 */
import type { Lang } from './translations'
import { isLocalizedZone, isRussianPath } from './lang-path'

/** Язык, который называет адрес витрины. */
export function urlLang(path: string): Lang {
  return isRussianPath(path) ? 'ru' : 'en'
}

/**
 * Язык экрана по адресу, сохранённому выбору и языку последней витрины.
 * `chosen` — `null`, если человек переключателем не пользовался.
 */
export function screenLang(path: string, chosen: Lang | null, lastStorefront: Lang): Lang {
  if (isLocalizedZone(path)) return urlLang(path)
  return chosen ?? lastStorefront
}
